import React, { Fragment } from 'react';
import { PatternFormat as NumberFormat } from 'react-number-format';
import { FormattedMessage } from 'react-intl';

export const SimpleDate = (props) => {
    const {
        label: {
            labelText,
            labelClasses,
            wrapperClasses,
            isRequired,
            ariaLabel,
        },
        input: {
            id,
            isInputRequired,
            inputClasses,
            name,
            value,
            readOnly=false,
            placeholder=undefined
        },
        actions: {
            handleFieldChange,
            handleFieldBlur
        }
    } = props;

    const handleChange = (values, sourceInfo) => {
        const { value } = values;
        const { event } = sourceInfo;
        event && handleFieldChange({ target: { value, name:event.target.name } });
    };

    const handleBlur = (values) => {
        const { value, name } = values.target;
        handleFieldBlur({ target: { value, name } });
    };
    return (
        <Fragment>
            <div className={`gi-simple-date ${wrapperClasses &&wrapperClasses.join(' ')}`}>
                <label
                    htmlFor={id}
                    className={`gi-simple-date__label ${labelClasses && labelClasses.join(' ')}`}
                    aria-label={ariaLabel}
                >
                    <span className={`required-${isRequired}`}>
                        <FormattedMessage id={labelText} />
                    </span>
                </label>
                <NumberFormat
                    id={id}
                    data-testid={id}
                    name={name}
                    className={`gi-simple-date__input ${inputClasses && inputClasses.join(' ')}`}
                    value={value}
                    readOnly = {readOnly}
                    displayType={'input'}
                    type={'text'}
                    format="##/##/####"
                    placeholder={placeholder}
                    onValueChange={(values, sourceInfo) => handleChange(values, sourceInfo)}
                    onBlur={(values) => handleBlur(values)}
                />
            </div>
        </Fragment>

    );
};